import styled from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';
import {CustomIcon} from '@guestapp/old-ui-kit';
import {ShareRegistrationLinkButton as ShareRegistrationLinkButtonComponent} from 'components/ShareRegistrationLinkButton';
import {MainButton} from 'styled/common';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  gap: 24px;
  width: 100%;

  @media (min-width: ${DEVICE.mobileL}) {
    max-width: 500px;
  }
  @media (min-width: ${DEVICE.laptopM}) {
    max-width: 856px;
  }
`;

export const StyledIcon = styled(CustomIcon)`
  margin: 0 auto 25px;
  display: block;
  width: 200px;
  height: 200px;
`;

export const Title = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.36px;
  margin-bottom: 8px;
  font-family: ${props => props.theme.fonts.fontFamily.titles.font_name};
  color: ${props => props.theme.colors.branding.fontPrimary};
`;

export const SubTitle = styled.div`
  font-style: normal;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  margin: 0 auto 72px;
  color: ${props => props.theme.colors.branding.fontSecondary};

  @media (min-width: ${DEVICE.laptop}) {
    width: 100%;
    text-align: center;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    max-width: 320px;
    margin: 0 auto 48px;
  }
`;

export const ShareRegistrationLinkButton = styled(ShareRegistrationLinkButtonComponent)`
  margin-bottom: 60px;
  margin-top: 32px;
`;

export const RegisterButton = styled(MainButton)`
  margin-top: 10px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 290px;
  margin-top: 24px;
`;

export const PmsGuestPanelContainer = styled.div`
  margin-bottom: 48px;
  margin-top: 56px;

  @media (min-width: ${DEVICE.laptop}) {
    width: 100%;
    margin-top: 0;
  }

  @media (min-width: ${DEVICE.laptop}) {
    margin-top: 0;
  }
`;
